import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule, MatButtonModule, MatDatepickerModule, MatInputModule, 
    MatNativeDateModule, MatCardModule, MatCheckboxModule, MatBadgeModule, MatRadioModule, MatTableModule, MatRadioChange, MatAutocompleteModule   } from '@angular/material';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
    imports: [
        CommonModule,
        MatTabsModule,
        MatButtonModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        MatCardModule,
        MatCheckboxModule,
        MatBadgeModule,
        MatRadioModule,
        MatTableModule,
        MatAutocompleteModule,
        OverlayModule
    ],
    exports: [
        MatTabsModule,
        MatButtonModule,
        MatDatepickerModule,
        OverlayModule,
        MatInputModule,
        MatNativeDateModule,
        MatCardModule,
        MatCheckboxModule,
        MatBadgeModule,
        MatRadioModule,
        MatTableModule,
        MatAutocompleteModule
    ],
    declarations: [
    ],
    providers: [
    ]
})

export class MaterialModule { 
   
}